module.exports = __webpack_public_path__ + "static/drew-houston-99e2a4ac99705bcb01180508b7159bb7.jpg";